import { Map } from 'immutable';
import get from 'lodash/get';

import * as FPAIConstants from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [FPAIConstants.ReducerKeys.FAMILY_PLAN_INVITE_TOKEN]: '',
  [FPAIConstants.ReducerKeys.IS_VALID_FAMILY_PLAN_INVITE_TOKEN]: false,
});

export default D.createReducer(INITIAL_STATE, {
  [FPAIConstants.Actions.SET_FAMILY_PLAN_INVITE_CODE]: onSetFamilyPlanInviteCode,
  [D.Constants.Api.ApiActions.FAMILY_PLAN_ACCEPT_INVITE_SUCCESS]: onAcceptFamilyPlanInviteSuccess,
});

function onSetFamilyPlanInviteCode(state, action) {
  const inviteToken = get(action, 'data.token');

  return state.set(FPAIConstants.ReducerKeys.FAMILY_PLAN_INVITE_TOKEN, inviteToken);
}

function onAcceptFamilyPlanInviteSuccess(state) {
  return state.merge({
    [FPAIConstants.ReducerKeys.IS_VALID_FAMILY_PLAN_INVITE_TOKEN]: true,
  });
}
